
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import React, {useState,useEffect } from "react";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Stack from '@mui/material/Stack';
import { getBotListFromLibrary, setupBotDeploymentConfig,getBotDeploymentConfigByEnv,deleteItemsFromDeploymentConfig} from "../../apis/bots";
import {getAgentsByEnvironment} from "../../apis/agents"
import { Table } from "../GenericReusableComponents/Table";
import {SelectEnvironment,SimpleButton,SelectInput,TButton} from "../GenericReusableComponents/HTMLWrappers"
import Grid from "@mui/material/Grid";
import { SelectList } from "./SelectBots";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';      
import {promoteBotsFromEnv} from "../../apis/bots"
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { LightTooltip } from '../LightTooltip';


export function DeployBot({ showDeployBot, setShowDeployBot}){

    const[selectedEnv,setSelectedEnv] = useState("PROD");
    const[bots,setBots] = useState([]);
    const[localBots,setLocalBots] = useState([]);
    const[agents,setAgents] = useState([]);
    const[deploymentProfile,setDeploymentProfile] = useState([]);
    const[orgDeploymentProfile,setOrgDeploymentProfile] = useState([]);
    const[botsChanged,setBotsChanged] = useState(false);
    const[agentsChanged,setAgentsChanged] = useState(false);
    const[enableAddToDeploymentProfileButton,setEnableAddToDeploymentProfileButton] = useState(false);
    const[enableDeployButton,setEnableDeployButton] = useState(false);
    const[deployStatus,setDeployStatus] = useState("");
    const[enablePromoteButton,setEnablePromoteButton] = useState(false);
    
   
    

    useEffect(()=>{
        if(!showDeployBot){
            // console.log("ShowDeployBot is false");
            return 
        }
        // console.log("ShowDeployBot is true")
        let mounted = true;
        
        if(mounted){
            getData(selectedEnv); 
            
                
            
            setDeployStatus("");
        }
        return ()=>(mounted = false);
        
    },[botsChanged,agentsChanged,showDeployBot]);


    
    const envList = [
        "DEV",
        "QA",
        "UAT",
        "PROD"
    ]

    




    function getData(env){
        // console.log(`Inside getData for ${env}`)

        getLocalBots()

        // *** Comment out to not need uploaded bots for now 
        getBotListFromLibrary().then((botList)=>{
            if(Array.isArray(botList)){
                setBots(botList);
            }else{
                setBots([]);
            }
        })

        getAgentsByEnvironment(env).then((agentList)=>{
            // console.log("getAgentsByEnvironment sucessfull")
            // console.log("Agents : "+ Array.isArray(agentList))
            if(Array.isArray(agentList))
                setAgents(agentList);
            else{
                setAgents([]);
            }
        })

        getBotDeploymentConfigByEnv(env).then((botAgentLinkList)=>{
            
            
            for(let i=0; i<botAgentLinkList.length;i++){
                botAgentLinkList[i].key = i;
            }
            // console.log(`getBotDeploymentConfigByEnv sucessfull ${JSON.stringify(botAgentLinkList)}`)
            

            setOrgDeploymentProfile(botAgentLinkList);
            setDeploymentProfile(botAgentLinkList);
            if(botAgentLinkList.length !=0){
                setEnablePromoteButton(true);
            }

        })

       // This is added to deal with close and reopen
        unCheckBoxs();
        setEnableDeployButton(false);
        setEnableAddToDeploymentProfileButton(false);

    }
  
    
    function getLocalBots(){

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json'}
          }
      
          fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/list/'  , requestOptions)
          .then (async response => {
            const data = await response.json();
            if (!response.ok) 
            {
              const error = (data && data.message) || response.status;
              console.log(error)
              return Promise.reject(error);
      
            }
            var bots = [];
            for (var i = 0; i < data.length; i++) {
                var ob = {}
                ob.botName = data[i];
                bots.push(ob);
            }
            console.log("local bots:" + bots)

            setLocalBots(bots)
          })
    
          .catch(error => {alert(error)});
    
    }
  

    function getSBTableHeader(){
        return (
            <tr>
            <th>Select Bots</th>
            <th></th>
            </tr>
        )
    }


    function renderBots(listOfBots){
        console.log(listOfBots)
        return  listOfBots.map( bot => 
            (
                
               
                <tr>
                    <td>
                    <FormControlLabel 
                        control={
                            <Checkbox 
                                name={bot.botName}
                                checked={bot.isChecked}
                                onChange={e => {
                                    
                                    console.log(`${e.target.name} ${e.target.checked}` );
                                    let lbots = [...bots];
                                    let i = lbots.findIndex(b=> b.botName === e.target.name);
                                    console.log(`Index ${i}`)
                                    lbots[i].isChecked = e.target.checked;                          
                                    setBots([...lbots]);

                                    if(isBotAndAgentSelected()){
                                        setEnableAddToDeploymentProfileButton(true);
                                    }

                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                                />
                            
                        } 
                        label={bot.botName}/>
                    </td>
                </tr>
            )
        )}

        function renderLocalBots(listOfBots){
            console.log(listOfBots)
            return  listOfBots.map( bot => 
                (
                    
                   
                    <tr>
                        <td>
                        <FormControlLabel 
                            control={
                                <Checkbox 
                                    name={bot.botName}
                                    checked={bot.isChecked}
                                    onChange={e => {
                                        
                                        console.log(`${e.target.name} ${e.target.checked}` );
                                        let lbots = [...localBots];
                                        let i = lbots.findIndex(b=> b.botName === e.target.name);
                                        console.log(`Index ${i}`)
                                        lbots[i].isChecked = e.target.checked;                          
                                        setLocalBots([...lbots]);
    
                                        if(isBotAndAgentSelected()){
                                            setEnableAddToDeploymentProfileButton(true);
                                        }
    
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                
                            } 
                            label={bot.botName}/>
                        </td>
                    </tr>
                )
            )}
    


    function getSBTableBody(){
        return ( 
            <>
                {/* <label>Library Bots</label> */}
                {/* {renderBots(bots)}                 */}
                {/* <label>Local Bots</label> */}
                {renderLocalBots(localBots)}                
            </>
            )
    }

    const SelectBots=()=>{
        const tbScrollStyle={
            margin:'0px',
            padding:'0px'
        }
    
        const tbContainerStyle={
            margin:'0px',
            padding:'0px'
        }

        const tbStyle={
            margin:'0px',
            padding:'0px'
        }

       
        return(
            <Table
            columns={getSBTableHeader()}
            rows={getSBTableBody()}
            tbcontainerstyle={tbContainerStyle}
            tbscrollstyle={tbScrollStyle}
            tbstyle={tbStyle}
            />
        )
    }




    function isSelectedPresentInDeploymentProfile(item){
        let i = deploymentProfile.findIndex(i => i.botName === item.botName && i.agentName === item.agentName);
        if(i === -1)
            return false;
        else
         return true
    }
    function isBotAndAgentSelected(){
        let checkedBots = bots.filter(b => b.isChecked === true);
        let checkedLocalBots = localBots.filter(b => b.isChecked === true);
        let checkedAgents = agents.filter(a => a.isChecked === true);
        let checkedB =  checkedBots.length != 0 || checkedLocalBots.length != 0

        if(checkedB && checkedAgents.length !=0){

           
            setEnableAddToDeploymentProfileButton(true);
        }else{
            setEnableAddToDeploymentProfileButton(false);
        }

    }

    function getSATableHeader(){
        return (
            <tr>
            <th>Select Agents</th>
            <th></th>
            </tr>
        )
    }

    function getSATableBody(){
        return(
            <>
            {
                agents.map(agent=>
                    (

                        <tr>
                            <td>
                             <FormControlLabel 
                                control={
                                    <Checkbox 
                                        name={agent.agentName}
                                        checked={agent.isChecked}
                                        onChange={e => {
   
                                            let lagents = [...agents];
                                            let i = lagents.findIndex(a=> a.agentName == e.target.name);
                                            // console.log(`Index ${i}`)
                                            lagents[i].isChecked = e.target.checked
                                            setAgents([...lagents])

                                            if(isBotAndAgentSelected()){
                                                setEnableAddToDeploymentProfileButton(true);
                                            }
                                            
                
                                        }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    
                                } 
                                label={agent.agentName}/>
                                </td>
                        </tr>
                    ))}
            </>
        )
    }

    const SelectAgents =()=>{
        const tbScrollStyle={
            margin:'0px',
            padding:'0px'
            
        }

        const tbStyle={
            margin:'0px',
            padding:'0px',
            width:"95%"
        }
    
        const tbContainerStyle={
            margin:'0px',
            padding:'0px'
        }

       
        return(
            <Table
            columns={getSATableHeader()}
            rows={getSATableBody()}
            tbcontainerstyle={tbContainerStyle}
            tbscrollstyle={tbScrollStyle}
            tbstyle={tbStyle}
            />
        )
    }
    // const SelectAgents =()=> {
    //     return (
    //         <>

    //         <Stack>
    //         <h3 style={{textAlign:'left'}}>2. Select Agents</h3>
    //         <div style={{height: '400px',overflow: 'auto'}}>
    //         <List>
    //         {
    //             agents.map(agent=>
    //                 (

                        
    //                     <ListItem>
    //                         <FormControlLabel 
    //                             control={
    //                                 <Checkbox 
    //                                     name={agent.agentName}
    //                                     checked={agent.isChecked}
    //                                     onChange={e => {
    //                                         // console.log(e.target.checked);
    //                                         //check if the item is already present in the deployment profile

    //                                         let lagents = [...agents];
    //                                         let i = lagents.findIndex(a=> a.agentName == e.target.name);
    //                                         // console.log(`Index ${i}`)
    //                                         lagents[i].isChecked = e.target.checked
    //                                         setAgents([...lagents])

    //                                         if(isBotAndAgentSelected()){
    //                                             setEnableAddToDeploymentProfileButton(true);
    //                                         }
                                            
                
    //                                     }}
    //                                     inputProps={{ 'aria-label': 'controlled' }}
    //                                     />
                                    
    //                             } 
    //                             label={agent.agentName}/>

    //                     </ListItem>
    //                )
    //            )
    //         }
    //         </List>
    //         </div>
    //         </Stack>
    //         </>
    //     ) 
 
    // }

 

    function getBotsCSV(botList){
        
        let retStr =""
        botList.forEach(a=>{
            retStr = retStr + a.botName +", "
        })
        return retStr.substring(0,retStr.length - 2);

    }

    function getAgentNameCSV(agentList){
        
        let retStr =""
        agentList.forEach(a=>{
            retStr = retStr + a.agentName +", "
        })
        return retStr.substring(0,retStr.length - 2);

    }

    function isNewDeploymentProfileEqToOrg(dp){


        return orgDeploymentProfile.length === dp.length && orgDeploymentProfile.every((o,i)=>
            o.botName === dp[i].botName && o.agentName === dp[i].agentName && o.configId === dp[i].configId
        )
    }

    function removeFromDeploymentProfile(e,profileItem){
        e.preventDefault();
        // console.log("removeFromDeploymentProfile " + JSON.stringify(profileItem))
        let ldeploymentProfile = [...deploymentProfile];
        // console.log("Deployment Profle "+ JSON.stringify(ldeploymentProfile))
        let i = ldeploymentProfile.findIndex(i => i.key === profileItem.key )
        // console.log(`Index ${i}`)
        ldeploymentProfile.splice(i,1);
        // console.log("Deployment Profle "+ JSON.stringify(ldeploymentProfile))
        setDeploymentProfile(ldeploymentProfile);
        if(isNewDeploymentProfileEqToOrg(ldeploymentProfile)){
            setEnableDeployButton(false);
            setEnablePromoteButton(true);
        }
        else{
            setEnableDeployButton(true);
            setEnablePromoteButton(false);
        }
    }

    function getRowStyle(item){
        
        let trStyle = {
            height : '60px'
        }
        if(item.isNewAdded){
            trStyle.backgroundColor = 'white';
            
        }
        return trStyle;
    }

   

    function getNextEnvForPromotion(){
        if(selectedEnv === "DEV"){
            return "QA";
        }

        if(selectedEnv === "QA"){
            return "UAT";
        }

        if(selectedEnv === "UAT"){
            return "PROD";
        }
    }
    
    function promoteToNextEnv(e){
        e.preventDefault();
        console.log(`Promote Bots from ${selectedEnv} To ${getNextEnvForPromotion()}`);

        promoteBotsFromEnv(selectedEnv,getNextEnvForPromotion(),afterBotsArePromoted);


    }

    function afterBotsArePromoted(){


        setDeployStatus("Successfully Promoted Bots to " + getNextEnvForPromotion());
        setTimeout(() => {
            setDeployStatus("");
        },3000);
        setEnablePromoteButton(false);

    }
    
    function getDPTableHeader(){
        const columns = ["Bot Name","Agents","Action"];
        return(
            columns.map(i =>(
                <th>{i}</th>
              ))
        )

    }

    function getDPTableBody(){
        return deploymentProfile.map(item => (
            <tr style={getRowStyle(item)}>
                <td>{item.botName}</td>
                <td>{item.agentName}</td>
                <td style={{textAlign:'center'}}>
                    <button onClick={e => removeFromDeploymentProfile(e,item)}>X</button>                 
                </td>
            </tr>
        ))
    }
    const DeploymentProfile = () =>{
        
        
        console.log(`Selected Env :  ${selectedEnv}`)
        const tbStyle = {
            width:"98%"
        }

        const tbContainerStyle={
            margin:'0px 0px 0px 10px',
            padding:'0px'
        }


        return(
            <>
           
            {/* <h3 style={{textAlign:"center"}}>Deployment Profile</h3> */}

            <Table columns={getDPTableHeader()} rows={getDPTableBody()}  tbstyle={tbStyle} tbcontainerstyle={tbContainerStyle} />

            {/* {!(selectedEnv === 'PROD' || deploymentProfile.length === 0) && <SimpleButton sname={promotionText} enable={enablePromoteButton} onClickHandler={promoteToNextEnv}/>} */}
           
           
            </>
        )
    }



    function deployBots(e){
        e.preventDefault();
        console.log("Deployment Profile "+ JSON.stringify(deploymentProfile));
        setDeployStatus("Deploying.....");
        if(isNewDeploymentProfileEqToOrg(deploymentProfile)){
            console.log("No changes to deployment profile");
            return
        }
        let newItemsInDp = getNewItemsInDeploymentProfile().map(item =>{
            return {botName: item.botName, agentId: item.agentId, agentName: item.agentName}
        })

        if(newItemsInDp.length !=0){
            setupBotDeploymentConfig(newItemsInDp,selectedEnv,setDeployStatus);
            console.log(`New Items In DP ${JSON.stringify(newItemsInDp)}}`)
        }else{
            console.log("No new Items in DP")
        }

        let deletedItemsInDp = getDeletedItemsInDeploymentProfile().map(item =>{
            return {botName: item.botName, configId: item.configId}
        })
        if(deletedItemsInDp.length !=0){
            deleteItemsFromDeploymentConfig(deletedItemsInDp,selectedEnv,setDeployStatus);
            console.log(`Deleted Item In DP ${JSON.stringify(deletedItemsInDp)}`)
        }else{
            console.log("No  Items deleted from  DP")
        }

        let ldeploymentProfile = [...deploymentProfile];
        ldeploymentProfile.forEach(i => i.isNewAdded = false);
        setDeploymentProfile(ldeploymentProfile);
    
        setEnableDeployButton(false);
        setEnablePromoteButton(true);
       
    }

    function getNewItemsInDeploymentProfile(){
        return deploymentProfile.filter(item =>{
            return item.configId === -1
        })
    }

    function getDeletedItemsInDeploymentProfile(){
       return orgDeploymentProfile.filter(oi=>{
            
           
            let i = deploymentProfile.findIndex(i=> i.configId === oi.configId);
            if( i === -1)
                return true;
            else
                return false;
       })
    }

    function getUpdatedItemsInDeploymentProfile(){
        return deploymentProfile.filter(item =>{
            return item.configId != -1
        })
    }

    function onSelectEnv(e){
        e.preventDefault();
        console.log(`onSelectEnv ${e.target.value}`)
        setSelectedEnv(e.target.value);
        getData(e.target.value);

    }


    
    function addToDeploymentProfile(event){
        event.preventDefault();
        
        // console.log("Called addToDeploymentProfile")
        let selectedBots = bots.filter(b => b.isChecked === true);
        let selectedLocalBots = localBots.filter(b => b.isChecked === true);
        selectedBots.push(...selectedLocalBots);
                
        let selectedAgents = agents.filter(a => a.isChecked === true);

        if(selectedBots.length == 0 ) return true;
        if(selectedAgents.legth == 0) return true;

        console.log(`selectedBots: ${JSON.stringify(selectedBots)} selectedAgents: ${JSON.stringify(selectedAgents)} ${typeof(selectedAgents)}`)
        // console.log("Add to Deployment profile")
        // selectedBots.forEach(b => console.log(`${b.botName} ${b.config}`));
        // selectedAgents.forEach(a => console.log(a.agentName));

        let ldeploymentProfile = [...deploymentProfile];
        selectedBots.forEach(b=>{
            selectedAgents.forEach(a =>{
                //check if the item is already present before adding
                let i = ldeploymentProfile.findIndex(lb => (lb.botName === b.botName) && (lb.agentName === a.agentName));
                
                if(i === -1){ //if item is not present
                    let item = { 
                        key: ldeploymentProfile.length + 1,
                        botName: b.botName,
                        botId: b.botId,
                        configId: -1,
                        agentId:a.agentId,
                        agentName:a.agentName,
                        isNewAdded:true
                    }
                    ldeploymentProfile.push(item);
                    setDeploymentProfile(ldeploymentProfile);
                    console.log(`Deployment profile  ${JSON.stringify(deploymentProfile)}`)
                    console.log(`Local Deployment profile  ${JSON.stringify(ldeploymentProfile)}`)
                          
                    setEnableDeployButton(true);
                    
            
                }
            })
            unCheckBoxs(); 
            setEnableAddToDeploymentProfileButton(false);
            setEnablePromoteButton(false);
           
        })
        
    
    }


    function unCheckBoxs(){
        let lbots = [...bots];
        lbots.forEach(b => b.isChecked = false);
        setBots(lbots);

        let myBots = [...localBots];
        myBots.forEach(b => b.isChecked = false);
        setLocalBots(myBots);


        let lagents = [...agents];
        lagents.forEach(a=> a.isChecked = false);
        setAgents(lagents);
    }
      
    
    function closeModal(){
        
        unCheckBoxs();
        setEnableDeployButton(false);
        setEnableAddToDeploymentProfileButton(false);
        setShowDeployBot(false);
    }

    function onBotSelect(){
        if(isBotAndAgentSelected()){
            setEnableAddToDeploymentProfileButton(true);
        }
    }
  
    if (!showDeployBot) {
        return "";
    }

    const disabledButtonStyle = {
            display:'flex', 
            // marginTop:'65px',
            marginTop:'10px',
            marginLeft:'35px',
            // height:'75px',
            // width:'150px',
            fontWeight:'bold',
            color:'lightgrey',
            backgroundColor:'grey',

        }

    const buttonStyle = {
        display:'flex', 
        marginTop:'10px',
        marginLeft:'35px',
        // marginTop:'65px',
        // height:'75px',
        // width:'150px',
        fontWeight:'bold',
        color:'white',
        backgroundColor:'royalblue',
        textTransform: 'none',
        "&:hover": {
            backgroundColor: '#244784'
          },        

    }
    
    const renderDeployButton=()=>{
        if (enableDeployButton)
        return(
            <div>
                <LightTooltip title="Deploy Bots">
                <button className="ipc dialogbtn" style={{margin:'10px'}} onClick={deployBots}>
                Deploy
                </button>
                </LightTooltip>
             </div>

        )
        else
        return(
            <div>
                <LightTooltip title="Deploy Bots">
                <button disabled className="ipc dialogbtn" style={{margin:'10px'}} onClick={deployBots}>
                Deploy
                </button>
                </LightTooltip>
             </div>

        )

    }

    return(
        <div className="modal">
            <div className="deploybot-modal-content">
          
                
                <Tooltip title="Close">
                    <IconButton
                        style={{ float: "right", position: "absolute", right: 0, top: 0 }}
                        onClick={() => setShowDeployBot(false)}
                    >
                        <CloseOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <form>
                        <Grid container spacing={0}>
                            <Grid item xs={12} style={{paddingBottom:'50px'}}>
                                <SelectEnvironment selectedEnv={selectedEnv} onChangeHandler={onSelectEnv}/>
                            </Grid>
                            {/* <Grid item xs={12}>
                                <p>{deployStatus}</p>
                            </Grid> */}
                            <Grid item xs={2}>
                                <SelectBots />
                            </Grid>
                            <Grid item xs={2}>
                                <SelectAgents/>
                            </Grid>
                                 
                                    {/* <Grid item xs={12}>
                                        
                                        <SimpleButton sname="Add To Deployment Profile" enable={enableAddToDeploymentProfileButton} onClickHandler={addToDeploymentProfile}/>
                                    </Grid> */}
                                
                            

                            <Grid item xs={1}>
                                {/* // <SimpleButton 
                                //     sname=">>" 
                                //     enable={enableAddToDeploymentProfileButton} 
                                //     onClickHandler={addToDeploymentProfile}
                                //     sbStyle={{marginTop:"0px",paddingTop:"0px"}}/> */}

                            <div>
                                <LightTooltip title="Add to Deployment Profile">
                               <IconButton 
                                    onClick={addToDeploymentProfile}
                                    // classes={{ root: buttonStyle, disabled: disabledButtonStyle }}                                    
                                    style={buttonStyle}
                                    disabled={!enableAddToDeploymentProfileButton}
                                >
                                    <DoubleArrowIcon fontSize="inherit" />
                                    </IconButton>
                                </LightTooltip>    
                            </div>
                            </Grid>
                           
                           
                            <Grid item xs={5.5}>
                                <DeploymentProfile/>
                            </Grid>

                            <Grid item xs={1.5}>
                                {/* <SimpleButton 
                                    sname="Deploy Bots" 
                                    enable={enableDeployButton} 
                                    onClickHandler={deployBots}
                                    sbStyle={{margin:"0px",paddingTop:"0px",width:'100%'}}/> */}
                                {renderDeployButton()}
                            </Grid>

                            <Grid item xs={12}>
                                <p>{deployStatus}</p>
                            </Grid>

                                
                           
                        </Grid>
                                
                                {/* <Divider orientation="vertical" flexItem/> */}
                                
                                
                         
                </form>


            </div>
        </div>
    )
}